import { useState } from "react";
import { Play } from "lucide-react";
import { EditorialArrow } from "./EditorialArrow";
import "./lesson-preview.css";

export const LearningProcessSection = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const playLesson = async () => {
    if (loading) return;
    setLoading(true);
    setError(false);
    try {
      const response = await fetch("/api/public/lesson-preview/playback", { cache: "no-store" });
      if (!response.ok) throw new Error("Playback unavailable");
      const data = await response.json();
      if (!data.url) throw new Error("Missing playback URL");
      setVideoUrl(data.url);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="learning" className="editorial-section editorial-lesson">
      <div className="editorial-container">
        <div className="lesson-heading">
          <div><p className="course-eyebrow">Урок из курса по нейросетям</p><h2><span className="ink-underline">Формат обучения</span></h2></div>
          <p className="editorial-intro">Посмотрите урок, чтобы понять, подходят ли вам мой темп и объяснения.</p>
        </div>
        <div className="lesson-stage">
          <div className="lesson-margin-note"><p className="editorial-handnote">Давайте разберёмся<br />вместе</p><EditorialArrow /></div>
          <div className="lesson-film" data-preview-active={Boolean(videoUrl || loading)}>
            <div className="film-caption"><span>Fokeev. / Как работает чат</span><span aria-hidden="true">● ● ●</span></div>
            <div className="editorial-video">
              {videoUrl ? (
                <video className="lesson-preview-player" aria-label="Как работает чат — пример урока" src={videoUrl}
                  controls autoPlay playsInline preload="metadata" onError={() => { setVideoUrl(null); setError(true); }} />
              ) : (
                <button onClick={playLesson} disabled={loading} aria-label="Посмотреть пример видеоурока" aria-busy={loading}>
                  <img src="/images/brand/practice-editorial-v1.webp" alt="" width="1200" height="800" loading="lazy" />
                  <span className="lesson-play"><Play size={20} fill="currentColor" />{loading ? "Загружаем урок…" : error ? "Повторить загрузку" : "Смотреть урок"}</span>
                </button>
              )}
            </div>
            {error && <div className="film-footer"><span role="alert">Не удалось загрузить видео. Попробуйте ещё раз.</span></div>}
          </div>
        </div>
      </div>
    </section>
  );
};
